import styled from "styled-components";
import Globais from "../../components/Globais";

export const Container = styled.section`
  width: 100%;
  min-height: auto;
  height: auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  @media (min-width: 200px) and (max-width: 399px) {
    text-align: center;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    text-align: center;
  }

  @media (min-width: 800px) {
    text-align: center;
  }
`;
export const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
`;

export const ContainerLista = styled.section`
  width: 100%;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column; /* empilha os itens em coluna */
  justify-content: flex-start;
  align-items: center; /* centraliza horizontalmente */

  @media (max-width: 799px) {
    padding: 0.5rem;
    min-width: 100%;
  }

  @media (max-width: 399px) {
    padding: 0.25rem;
    min-width: 100%;
  }
`;
export const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  // border: 2px solid orange;
  // background-color: orange;
`;
export const TituloLista = styled.h2`
  text-align: center;
  color: ${Globais.CorTexto};
  font-size: 1.5rem;
  width: 100%;
  @media (min-width: 500px) {
    width: 100%;
    font-size: 2rem;
  }
`;

export const ListaWrapper = styled.div`
  display: grid;
  // border: 2px solid red;
  grid-template: 10% 0.1% 90% / 100%;
  justify-content: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  background-color: #fff;
  border-radius: 10px;

  @media (min-width: 200px) and (max-height: 799px) {
    grid-template: 14% 2% 84% / 100%;
  }
  @media (min-width: 200px) and (min-height: 800px) and (max-height: 999px) {
    grid-template: 12% 0.1px 90% / 100%;
  }
  @media (min-width: 200px) and (min-height: 1000px) and (max-height: 1299px) {
    grid-template: 10% 0.1px 92% / 100%;
  }
  @media (min-width: 200px) and (min-height: 1300px) and (max-height: 1799px) {
    grid-template: 8% 0.1px 93% / 100%;
  }
  @media (min-width: 200px) and (min-height: 1800px) {
    grid-template: 6% 0.1px 93% / 100%;
  }
`;
export const ContainerSubTitulo = styled.div`
  width: 100%;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: grid;
  grid-template: 100% / 20% 60% 20%;

  // background-color: pink;
`;
export const MaisWrapper = styled.button`
  width: 3rem;
  height: 3rem;
  border: none;
  background-color: transparent;
  margin-right: 0.5rem;
  margin-bottom: 2rem;
  @media (min-width: 1276px) {
    width: 4rem;
    height: 4rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
  &:hover {
    cursor: pointer;
  }
  @media (max-height: 550px) {
    width: 2.5rem;
    height: 2.5rem;
    margin-bottom: 3rem;
  }
  @media (max-height: 700px) {
    width: 2.8rem;
    height: 2.8rem;
    margin-bottom: 2.5rem;
  }
`;
export const ContainerPeriodos = styled.div`
  width: 100%;
  height: 100%;
  // border: 2px solid blue;
`;

export const ImagemMais = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
`;
export const ContainerIncluirPeriodo = styled.form`
  width: 100%;
  height: 100%;
  display: grid;

  grid-template: 30% 30% 18% 22%/100%;
  justify-content: center;
  align-items: center;

  @media (min-width: 1276px) {
    display: grid;

    flex-direction: row;
  }

  #checkIn {
    width: 2.5rem;
    height: 2rem;
    font-size: 1rem;
    color: ${Globais.CorAzulBackGround};
    border: 1px solid ${Globais.CorAzulBackGround};
    border-radius: 10px;
    margin-left: 0.5rem;
    text-align: center;
    padding-left: 0.5rem;
    &:hover {
      cursor: pointer;
    }
  }
  #checkOut {
    width: 2.5rem;
    height: 2rem;
    font-size: 1rem;
    color: ${Globais.CorAzulBackGround};
    border: 1px solid ${Globais.CorAzulBackGround};
    border-radius: 10px;
    margin-left: 0.5rem;
    text-align: center;
    padding-left: 0.5rem;
    &:hover {
      cursor: pointer;
    }
  }

  #divCheckIn {
    width: 100%;
    height: 100%;
    display: flex;

    justify-content: center;
    align-items: center;

    flex-direction: column;
    input {
      width: 40%;
      max-width: 20rem;
      height: 3rem;
    }
  }
  #divCheckOut {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

    align-items: center;
    flex-direction: column;

    input {
      width: 40%;
      max-width: 20rem;
      height: 3rem;
    }
  }

  #alerta {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #botaoIncluir {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    margin-top: 2rem;

    align-items: center;
    flex-direction: column;
    input {
      width: 30%;
    }
  }
`;

export const H3 = styled.h3`
  color: ${Globais.CorAzulBackGround};
  text-align: center;
`;
export const H2 = styled.h2`
  color: ${Globais.CorAzulBackGround};
  text-align: center;
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  @media (min-width: 500px) {
    width: 100%;
    font-size: 1.5rem;
  }
`;
export const H2Cota = styled.h2`
  color: ${Globais.CorAzulBackGround};
  text-align: center;
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  @media (min-width: 500px) and (max-height: 599px) {
    margin-bottom: -0.8rem;
    font-size: 1.2rem;
  }
  @media (min-width: 500px) and (min-height: 600px) {
    width: 100%;
    font-size: 1.5rem;
  }
`;

export const Seta = styled.img`
  width: 3rem;
  height: 3rem;

  cursor: pointer;
  margin-top: 1rem;
  margin-left: 1rem;
  @media (max-height: 650px), (max-width: 650px) {
    width: 2rem;
    height: 2rem;
    margin-top: 0.5rem;
  }
`;
export const ContainerMais = styled.div`
  width: 100%;

  height: 6rem;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  // border: 2px solid black;
`;
export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;
export const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 5% 1fr 15%;

  justify-content: center;
  align-items: center;
`;
export const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContainerAdicionarPeriodo = styled.section`
  width: 100%;
  height: 100%;
  grid-column-start: 3;
  display: flex;

  justify-content: center;
  align-items: center;
`;
export const ContainerItems = styled.div`
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
  max-height: 200px;
  overflow-y: auto; /* ou scroll, hidden, visible */
`;

export const Items = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  strong {
    font-weight: bold;
    color: #555;
  }
`;
// export const ContainerFra = styled.div`
//   display: flex;
//   width: 100%;
//   flex-direction: column;
//   align-items: center;
//   // padding-left: 16px;
// `;

export const ContainerFra = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;


// export const ItemsFra = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 90%;
//   // margin-top: 8px;
//   padding: 12px 16px;
//   background-color: #fff;
//   border-radius: 10px;
//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
//   font-size: 14px;
//   color: #333;
//   line-height: 1.6;
//   gap: 6px;

//   strong {
//     font-weight: 600;
//     color: #1a1a1a;
//     margin-right: 4px;
//   }

//   span {
//     display: inline-block;
//   }
// `;

export const ItemsFra = styled.div`
  position: relative; /* necessário para posicionamento absoluto interno */
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  gap: 6px;
  margin-bottom: 12px;
`;



export const Icon = styled.span`
  font-size: 16px;
  color: #666;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

export const StyledButton = styled.button`
  margin-bottom: 10px;
  width: 100%;
`;
